import { render } from "./BasicUserInformationCard.vue?vue&type=template&id=67b7163c&scoped=true"
import script from "./BasicUserInformationCard.vue?vue&type=script&lang=js"
export * from "./BasicUserInformationCard.vue?vue&type=script&lang=js"

import "./BasicUserInformationCard.vue?vue&type=style&index=0&id=67b7163c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b7163c"]])

export default __exports__